import { createContext } from 'react'

interface RichTextEditorContextType {
  tools: { id: string; label: string; type: 'tool' }[]
  variables: { id: string; label: string; type: 'variable' }[]
}

export const RichTextEditorContext = createContext<RichTextEditorContextType>({
  tools: [],
  variables: [
    {
      id: 'customer_name',
      label: 'Customer Name',
      type: 'variable',
    },
    {
      id: 'customer_email',
      label: 'Customer Email',
      type: 'variable',
    },
  ],
})
